import { createBrowserRouter, Navigate } from "react-router-dom";
import { LoginPage } from "@/features/auth/components/login-page";
import { ChangePasswordPage } from "@/features/auth/components/change-password-page";
import { SchedulesPage } from "@/features/schedules/components/schedules-page";
import { NewSchedulePage } from "@/features/schedules/components/new-schedule-page";
import { ScheduleHomePage } from "@/features/schedules/pages/schedule-home-page";
import { UsersPage } from "@/features/users/components/users-page";
import { MainLayout } from "@/components/layouts/main-layout";
import { ProtectedRoute } from "@/components/layouts/protected-route";
import { PublicRoute } from "@/components/layouts/public-route";
import { USERS_ADMIN_ROLES } from "@/features/auth/permissions";
import { NotFoundPage } from "./not-found-page";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Navigate to="/schedules" replace />,
  },
  {
    element: <PublicRoute />,
    children: [{ path: "/login", element: <LoginPage /> }],
  },
  {
    element: <ProtectedRoute allowDuringPasswordChange />,
    children: [{ path: "/change-password", element: <ChangePasswordPage /> }],
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <MainLayout />,
        children: [
          { path: "/schedules", element: <SchedulesPage /> },
          { path: "/schedules/new", element: <NewSchedulePage /> },
          { path: "/schedules/:id", element: <ScheduleHomePage /> },
        ],
      },
    ],
  },
  {
    element: <ProtectedRoute allowedRoles={USERS_ADMIN_ROLES} />,
    children: [
      {
        element: <MainLayout />,
        children: [{ path: "/users", element: <UsersPage /> }],
      },
    ],
  },
  { path: "*", element: <NotFoundPage /> },
]);
